var map = {
	"./GitHub-Mark/PNG/GitHub-Mark-120px-plus.png": 7125,
	"./GitHub-Mark/PNG/GitHub-Mark-32px.png": 2579,
	"./GitHub-Mark/PNG/GitHub-Mark-Light-32px.png": 4575,
	"./GitHub-Mark/PNG/GitHub-Mark-Light-64px.png": 5634,
	"./GitHub-Mark/Vector/GitHub-Mark.ai": 6809,
	"./GitHub-Mark/Vector/GitHub-Mark.eps": 6605,
	"./avo.png": 7010,
	"./avo_scroll_up.png": 3957,
	"./codeology.png": 9914,
	"./codeology_text.png": 2146,
	"./email_green.svg": 1293,
	"./facebook.png": 5075,
	"./github-footer.png": 2990,
	"./github-icon.png": 5051,
	"./instagram.png": 3427,
	"./linkedin.png": 9684,
	"./linkedin_green.svg": 8807,
	"./resume_green.svg": 5409,
	"./web_green.svg": 8145
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4296;